__turbopack_context__.v({
  "className": "inter_da96be98-module__YM1J6a__className",
  "variable": "inter_da96be98-module__YM1J6a__variable",
});
